module.exports = __webpack_public_path__ + "img/ico_return_arrow_right.80bc9099.svg";